import React from "react";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect, Dispatch } from "react-redux";
import { RouteProps, Redirect } from "react-router";
import { Grid, Typography } from "material-ui";
import { SetShowBackNavigation } from "ducks/common";

/**
 * Props provided by redux
 */
interface ITermsPageStateProps {}

/**
 * Dispatch functions provided by redux
 */
interface ITermsPageDispatchProps {
    showBackNavigation: () => void;
    HideBackButton: () => void;
}

/**
 * Internal state of this component
 */
interface ITermsPageState {}
interface ITermsReduxProps {}

/**
 * Combined properties of he component
 */
type ITermsPageProps = ITermsPageStateProps &
    ITermsPageDispatchProps &
    RouteProps;

class TermsPage extends React.Component<ITermsPageProps, ITermsPageState> {
    constructor(props: ITermsPageProps) {
        super(props);
    }

    componentDidMount() {
        this.props.showBackNavigation();
    }

    componentWillUnmount() {
        this.props.HideBackButton();
    }

    public render() {
        return (
            <div className="ReactTemplate__TermsPage">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        wordWrap: "normal",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid
                            className="text-container"
                            item
                            xs={12}
                            sm={10}
                            md={10}
                            lg={10}
                        >
                            <h2>
                                Mobiilipankin käyttöehdot
                            </h2>

                            <h2>1. Yleistä</h2>

                            <Typography>
                                Näitä käyttöehtoja sovelletaan Suomen 
                                Hypoteekkiyhdistyksen (jäljempänä ”Hypo” 
                                tai ”Palveluntarjoaja”) Mobiilipankki -nimisen 
                                sovellukseen (jäljempänä ”Mobiilipankki”) ja 
                                sen käyttöön. Mobiilipankki on tarkoitettu 
                                henkilöasiakkaiden (jäljempänä ”käyttäjä”) 
                                käyttöön. Käyttämällä Mobiilipankkia käyttäjä 
                                hyväksyy samalla nämä käyttöehdot itseään 
                                sitoviksi.
                            </Typography>

                            <h2>2. Mobiilipankin käytön edellytykset</h2>

                            <Typography>
                                Mobiilipankin käyttö edellyttää käyttäjän 
                                rekisteröitymistä Mobiilipankin käyttäjäksi 
                                ensimmäisen sisäänkirjautumisen yhteydessä. 
                                Rekisteröityminen edellyttää vahvan sähköisen 
                                tunnistamispalvelun käyttämistä, jossa käyttäjä 
                                tunnistetaan ja hänen henkilöllisyytensä 
                                todennetaan sähköisesti ensitunnistajan 
                                kuten käyttäjän oman maksuliikennepankin 
                                käyttäjälle luomien ja luovuttamien 
                                verkkopankkitunnusten (jäljempänä ”Tunniste”) 
                                avulla. Tunnistautumisen jälkeen käyttäjä voi 
                                kirjautua Mobiilipankkiin käyttämällä 
                                sisäänkirjautumisessa joko käyttäjän itselleen 
                                Mobiilipankkiin luomiaan tunnuksia (jäljempänä 
                                ”Tunnus”) tai vahvaa sähköistä tunnistamista. 
                                <br />
                                <br />
                                Tunnisteita on säilytettä niitä koskevien 
                                sopimusehtojen mukaan huolellisesti. 
                                <br />
                                <br />
                                Tunnukset ovat henkilökohtaiset eikä niitä 
                                saa luovuttaa muille. Käyttäjä sitoutuu 
                                säilyttämään ja käyttämään Tunnuksiaan 
                                huolellisesti ja turvallisesti. 

                            </Typography>

                            <h2>3. Tunnisteiden ja Tunnusten käytön 
                                oikeusvaikutukset</h2>

                            <Typography>
                                Käyttäjän Tunnisteiden tai Tunnusten käyttö 
                                Mobiilipankissa vastaa käyttäjän tunnistamista 
                                henkilöllisyyttä osoittavista asiakirjoista.
                                <br />
                                <br />
                                Käyttäjän Tunnisteiden tai Tunnusten käyttö 
                                Mobiilipankissa sähköisten viestien, hakemusten 
                                ja sopimusten vahvistamisessa vastaa käyttäjän 
                                omakätistä allekirjoitusta.
                            </Typography>

                            <h2>4. Käyttäjän velvollisuudet</h2>

                            <Typography>
                                Mobiilipankin käyttöön sovelletaan näitä 
                                käyttöehtoja sekä Hypon antamia ohjeita ja 
                                suosituksia (kuten Tietoa Mobiilipankista). 
                                Ristiriitatilanteessa nämä Mobiilipankin 
                                käyttöehdot ovat ensisijaiset suhteessa 
                                ohjeisiin ja suosituksiin.  
                                <br />
                                <br />
                                Käyttäjä vastaa siitä, että hänellä on 
                                Mobiilipankin käytön edellyttämät sekä 
                                tietoturvan kannalta tarpeelliset ja 
                                riittävät laitteet, ohjelmat ja 
                                tietoliikenneyhteydet. Käyttäjä vastaa 
                                Mobiilipankin käytön edellyttämien 
                                ohjelmistojen, laitteiden ja 
                                tietoliikenneyhteyksien ylläpidosta ja 
                                tietoturvapäivityksistä ja niihin liittyvistä 
                                kuluista ja kustannuksista. Hypo ei kuitenkaan 
                                takaa, että Mobiilipankkia voidaan käyttää 
                                käyttäjän hankkimilla laitteilla, ohjelmilla, 
                                järjestelmillä tai liittymillä.
                            </Typography>

                            <h2>5. Palveluntarjoaja</h2>

                            <Typography>
                                Hypo on Mobiilipankin Palveluntarjoaja, joka 
                                ylläpitää ja kehittää Mobiilipankkia. 
                                <br />
                                <br />
                                Rekisteröitymisen yhteydessä käyttäjän vahvan 
                                sähköisen tunnistamisen tiedot välitetään 
                                Hypolle tai sen kanssa samaan konserniin 
                                kuuluvalle Suomen Asuntohypopankki Oy:lle 
                                (jäljempänä ”AHP”).
                                <br />
                                <br />
                                Mobiilipankissa tarjottavista tuotteista ja 
                                palveluista vastaavat luottojen ja niihin 
                                liittyvien vakuuksien osalta Hypo ja tilien 
                                ja talletusten osalta AHP (jäljempänä molemmat 
                                yhdessä ja erikseen ”Palveluntarjoaja”):
                                <br />
                                <br />
                                Nimi: Suomen Hypoteekkiyhdistys
                                <br />
                                Kotipaikka: Helsinki, Suomi
                                <br />
                                Käyntiosoite: Yrjönkatu 9 A, 00120 Helsinki
                                <br />
                                Postiosoite: PL 509, 00101 Helsinki
                                <br />
                                Y-tunnus: 0116931-8
                                <br />
                                Puhelin (vaihde): +358 9 228 361
                                <br />
                                Sähköposti:&nbsp;
                                <a href="mailto:hypo@hypo.fi">hypo@hypo.fi</a>
                                <br />
                                <br />
                                Nimi: Suomen Asuntohypopankki Oy
                                <br />
                                Kotipaikka: Helsinki, Suomi
                                <br />
                                Käyntiosoite: Yrjönkatu 9 A, 00120 Helsinki
                                <br />
                                Postiosoite: PL 509, 00101 Helsinki
                                <br />
                                Y-tunnus: 0362481-2
                                <br />
                                Puhelin (vaihde): +358 9 228 361
                                <br />
                                Sähköposti:&nbsp;
                                <a href="mailto:hypo@hypo.fi">hypo@hypo.fi</a>
                            </Typography>

                            <h2>6. Mobiilipankin tuote- ja palveluvalikoima</h2>

                            <Typography>
                                Mobiilipankin ensisijainen tarkoitus on 
                                tarjota käyttäjälle tietoa käyttäjän ja 
                                palveluntarjoajan välisiin sopimuksiin 
                                perustuvista tuotteista ja palveluista, 
                                kuten talletustileistä tai lainoista. 
                                Mobiilipankin Palveluntarjoaja määrittää ja 
                                päättää Mobiilipankin tuote- ja palveluvalikoiman 
                                sekä palvelussa esitettävät tiedot. 
                                <br />
                                <br />
                                Palveluntarjoaja ei takaa Mobiilipankissa 
                                esitettävien tietojen ajantasaisuutta. Osa 
                                Mobiilipankissa esitettävästä sisällöstä on 
                                vain arvioita. 
                            </Typography>

                            <h3>6.1. Viestit</h3>

                            <Typography>
                                Mobiilipankissa voidaan lähettää ja 
                                vastaanottaa viestejä tietoturvallisesti 
                                käyttäjän ja Palveluntarjoajan välillä. 
                            </Typography>

                            <h3>6.2. Hakemukset ja toimeksiannot</h3>

                            <Typography>
                                Käyttäjä voi tehdä Mobiilipankissa 
                                hakemuksia ja antaa Palveluntarjoajalle 
                                toimeksiantoja, kuten talletuksen nostopyyntöjä. 
                                Palveluntarjoaja pidättää itsellään oikeuden 
                                olla hyväksymättä ja/tai toteuttamatta käyttäjän 
                                Mobiilipankissa antamia toimeksiantoja. 
                                Hyväksymättä tai toteuttamatta jääneestä 
                                toimeksiannosta ilmoitetaan käyttäjälle 
                                erikseen sovittavalla tavalla.
                            </Typography>

                            <h3>6.3. Talletustilit ja tilitiedot</h3>

                            <Typography>
                                Palveluntarjoaja voi antaa käyttäjälle 
                                Mobiilipankkiin liitettyjä talletustilejä 
                                koskevia tilitietoja Mobiilipankissa. 
                                Nähdäkseen tietoja talletustileistä 
                                Mobiilipankissa, käyttäjän tulee olla 
                                talletustilin tilinomistaja tai sellainen 
                                talletustilin käyttöön oikeutettu luonnollinen 
                                henkilö, jolla on oikeus käyttää talletustiliä 
                                yksin joko tilinomistajan valtuutuksen, lain, 
                                tuomioistuimen päätöksen tai viranomaisen 
                                määräyksen perusteella. 
                            </Typography>

                            <h3>6.4. Lainat ja lainatiedot</h3>

                            <Typography>
                                Palveluntarjoaja voi antaa käyttäjälle 
                                Mobiilipankissa käyttäjän lainoja koskevia 
                                tietoja. Nähdäkseen tietoja lainoista 
                                Mobiilipankissa, käyttäjän tulee olla 
                                lainan velkakirjaan velalliseksi merkitty 
                                luonnollinen henkilö. 
                            </Typography>

                            <h3>6.5. Muut tuotteet tai tiedot</h3>

                            <Typography>
                                Palveluntarjoaja voi antaa käyttäjälle 
                                talletusten ja lainojen lisäksi myös muita 
                                Palveluntarjoajan tai kolmannen osapuolen 
                                tuotteita ja palveluita koskevia tietoja. 
                            </Typography>

                            <h3>6.6. Mobiilipankin arkisto</h3>

                            <Typography>
                                Mobiilipankin arkistoon tallennetaan
                                <ul>
                                    <li>
                                        käyttäjän Mobiilipankissa lähettämät ja 
                                        vastaanottamat viestit sekä
                                    </li>
                                    <li>
                                        erikseen sovitut tuote- ja palvelukohtaiset 
                                        otteet kuten tiliotteet sekä tiedotteet.
                                    </li>
                                </ul>
                            </Typography>

                            <h2>7. Muutokset Mobiilipankkiin ja Mobiilipankin 
                                käyttöehtoihin</h2>

                            <Typography>
                                Hypolla on oikeus muuttaa Mobiilipankissa 
                                tarjottavien tuotteiden ja palveluiden 
                                valikoimaa, palvelun sisältöä, palvelun 
                                saatavuutta sekä palvelun käyttöön tarvittavien 
                                laitteiden ja ohjelmien vaatimuksia:
                                <ul>
                                    <li>
                                        ilmoittamatta siitä asiakkaalle etukäteen
                                    </li>
                                    <li>ottamalla muutos käyttöön ja</li>
                                    <li>kertomalla muutoksesta Mobiilipankissa.</li>
                                </ul>
                                Hypo pidättää oikeuden päivittää Mobiilipalvelua 
                                ja sulkea Mobiilipankki milloin tahansa. Hypo 
                                pidättää oikeuden muuttaa näitä käyttöehtoja. 
                                Käyttäjä hyväksyy päivitykset ja muutokset 
                                jatkamalla Mobiilipankin käyttöä. 
                            </Typography>

                            <h2>
                                8. Palveluntarjoajan ja käyttäjän välinen
                                viestintä
                            </h2>

                            <h3>8.1. Palveluntarjoajan ilmoitukset</h3>

                            <Typography>
                                Palveluntarjoajalla on oikeus lähettää 
                                käyttäjälle Mobiilipankkia, hakemuksia ja 
                                toimeksiantoja koskevat ilmoitukset, kuten 
                                tiedonannot, tarjoukset, vastaukset, vahvistukset 
                                ja muut vastaavat viestit, käyttäjän saataville 
                                Mobiilipankkiin. 
                            </Typography>

                            <h3>8.2. Käyttäjän yhteydenotot</h3>

                            <Typography>
                                Käyttäjä voi olla yhteydessä Palveluntarjoajaan 
                                sähköisesti Mobiilipankin viestitoiminnon tai 
                                Palveluntarjoajan tarjoaman muun suojatun 
                                sähköisen palvelun välityksellä, kirjallisesti, 
                                puhelimitse taikka asioimalla Palveluntarjoajan 
                                konttorissa. 
                            </Typography>

                            <h3>8.3. Käyttäjän huomautukset</h3>

                            <Typography>
                                Mobiilipankkia koskevat huomautukset tai 
                                vaatimukset Hypolle on tehtävä kirjallisesti 
                                tai Mobiilipankin viestitoiminnolla viipymättä, 
                                viimeistään kuitenkin 14 päivän kuluessa, ellei 
                                laista tai muusta pakottavasta sääntelystä muuta 
                                johdu. Lainoja ja talletustilejä koskevat 
                                huomautukset on tehtävä Palveluntarjoajalle 
                                laina- ja tiliehtojen mukaisesti. 
                            </Typography>

                            <h2>9. Kolmannet osapuolet</h2>

                            <h3>9.1. Kolmannen osapuolen tuottama tieto</h3>

                            <Typography>
                                Mobiilipankki voi sisältää kolmannen 
                                osapuolen tuottamaa tietoa. Palveluntarjoaja 
                                ei vastaa Mobiilipankin sisältämästä kolmannen 
                                osapuolen tuottamasta tai julkaisemasta 
                                tiedosta tai materiaalista. Tieto tai materiaali 
                                voi myös olla kolmannen osapuolen omalla 
                                sivustolla tai palvelussa, johon Mobiilipankista 
                                on linkki. 
                            </Typography>

                            <h3>
                                9.2. Kolmannen osapuolen ja käyttäjän väliset
                                sopimukset
                            </h3>

                            <Typography>
                                Kolmannen osapuolen tuotteisiin ja 
                                palveluihin sovelletaan yksinomaan käyttäjän 
                                ja kolmannen osapuolen välisen sopimuksen 
                                ehtoja. Palveluntarjoaja ei ota kantaa eikä 
                                vastaa kolmannen osapuolen tarjoamista tuotteista 
                                tai palveluista ja niiden turvallisuudesta. 
                                Palveluntarjoaja ei ole osapuolena käyttäjän 
                                ja kolmannen osapuolen välisessä sopimuksessa 
                                eikä vastaa siihen liittyvistä velvollisuuksista, 
                                virheistä tai viivästyksistä.
                            </Typography>

                            <h3>9.3. Käyttäjän huomautukset</h3>

                            <Typography>
                                Kolmannen osapuolen tuottamaa tietoa, 
                                materiaalia tai tuotetta taikka palvelua 
                                koskevat huomautukset tai vaatimukset on 
                                osoitettava suoraan kolmannelle osapuolelle.
                            </Typography>

                            <h2>10. Immateriaalioikeudet</h2>

                            <Typography>
                                Mobiilipankin ja kaiken Mobiilipankissa 
                                esitettävän aineiston omistusoikeus ja 
                                tekijänoikeus © sekä kaikki muut 
                                immateriaalioikeudet kuuluvat Hypolle tai 
                                erikseen ilmoitetulle muulle taholle. Kaikki 
                                oikeudet on pidätetty kaikissa maissa. 
                                Mobiilipankin sisällön tai sen osan julkaiseminen, 
                                jäljentäminen, siirtäminen tai säilyttäminen 
                                ilman oikeuksien omistajan lupaa on kielletty. 
                                Käyttäjällä on oikeus tallentaa omaan käyttöönsä 
                                tietoja Mobiilipankista. Aineistoa saa lainata 
                                Suomen tekijänoikeuslain (404/1961) mukaisesti. 
                                Aineistoa lainattaessa on aina ilmoitettava lähde.
                                Mobiilipankkiin sisältyviä tavara- ja 
                                liikemerkkejä ei kuitenkaan saa kopioida, 
                                julkaista tai edelleen levittää ilman Hypon 
                                kirjallista lupaa. 
                                <br />
                                <br />
                                Mobiilipankki käyttää laskennassa Tilastokeskuksen 
                                julkaisemaa tietoa ja osa Mobiilipankissa 
                                näkyvästä tiedosta perustuu Tilastokeskuksen 
                                aineistoon. Tilastokeskuksen käyttöehtoihin 
                                voi tutustua Tilastokeskuksen verkkosivuilla. 
                                Hypo varaa oikeuden päivittää Mobiilipankissa 
                                käytettäviä Tilastokeskuksen julkaisemia tietoja. 
                            </Typography>

                            <h2>11. Vastuunrajoitus</h2>

                            <Typography>
                                Mobiilipankissa annettua tietoa ei voida 
                                missään tilanteessa pitää osto- tai 
                                myyntikehotuksena tai suosituksena kenenkään 
                                palveluntarjoajan taholta, ellei Palveluntarjoaja 
                                nimenomaan toisin ilmoita. Sama koskee kaikkia 
                                lainkäyttöalueita, joilla laki ei salli 
                                tarjousten, kehotusten tai suositusten 
                                esittämistä. Mobiilipankki ja sen sisältämä 
                                tietoon suunnattu yksinomaan Suomeen, ellei 
                                erikseen ole nimenomaisesti muuta sovittu tai 
                                ilmoitettu. Mobiilipankissa annettua tietoa 
                                ei myöskään voida missään tilanteessa pitää 
                                sen antajaa sitovana laina- tai muuna tarjouksena, 
                                ellei erikseen ja nimenomaisesti ole toisin 
                                ilmoitettu. 
                                <br />
                                <br />
                                Palveluntarjoaja ei vastaa Mobiilipankin 
                                tietojen oikeellisuudesta. Palveluntarjoaja 
                                ei vastaa mistään mahdollisesta kulusta, 
                                menetyksestä taikka välillisestä tai välittömästä 
                                vahingosta, joka aiheutuu Mobiilipankin sisällön 
                                virheistä, puutteista tai toimimattomuudesta.
                            </Typography>

                            <h2>12. Henkilötietojen käsittely</h2>

                            <Typography>
                                Palveluntarjoaja käsittelee Mobiilipankissa 
                                käyttäjän henkilötietoja Hypo-konsernin 
                                henkilörekistereistä julkistettujen 
                                tietosuojaselosteiden mukaisella tavalla. 
                                Tietosuojaselosteet ovat saatavissa 
                                Palveluntarjoajan verkkosivuilla osoitteessa&nbsp;
                                <a href="www.hypo.fi/tietosuoja">
                                    www.hypo.fi/tietosuoja</a>.
                            </Typography>

                            <h2>13. Valvova viranomainen</h2>

                            <Typography>
                                Palveluntarjoajan toimintaa valvovat 
                                Finanssivalvonta&nbsp;
                                <a href="www.finanssivalvonta.fi">
                                    (www.finanssivalvonta.fi)</a>&nbsp;ja 
                                kuluttaja-asiamies&nbsp;
                                <a href="www.kkv.fi">(www.kkv.fi)</a>. 
                                Tietosuojavaltuutettu&nbsp;
                                <a href="www.tietosuoja.fi">
                                    (www.tietosuoja.fi)</a>&nbsp;valvoo 
                                henkilötietoja koskevien säännösten 
                                noudattamista. 
                                <br />
                                <br />
                                Finanssivalvonnan yhteystiedot ovat:
                                <br />
                                Finanssivalvonta, Snellmaninkatu 6, PL 103, 
                                00101 Helsinki, puhelin 09 183 51 (vaihde). <br />
                                <br />
                                Kuluttaja-asiamiehen yhteystiedot ovat:
                                <br />
                                Kilpailu- ja kuluttajavirasto, Lintulahdenkuja 2, 
                                00530 Helsinki, PL 5, 00531 Helsinki, puhelin 
                                029 505 3000 (vaihde).
                                <br />
                                <br />
                                Tietosuojavaltuutetun toimiston yhteystiedot
                                ovat:
                                <br />
                                Tietosuojavaltuutetun toimisto Lintulahdenkuja 4, 
                                00530 Helsinki, PL 800, 00531 Helsinki, 
                                puhelin 029 566 6700 (vaihde).
                            </Typography>

                            <h2>14. Kohdemaa</h2>

                            <Typography>
                                Mobiilipankki on tehty täyttämään Suomen 
                                kansallisten lakien ja viranomaismääräysten 
                                mukaiset vaatimukset. Tämän takia Mobiilipankki 
                                on suomenkielinen palvelu, joka on tarkoitettu 
                                käytettäväksi yksinomaan Suomen markkinoilla. 
                            </Typography>

                            <h2>15. Sovellettava laki ja oikeuspaikka</h2>

                            <Typography>
                                Mobiilipankin käyttöön ja Mobiilipankin 
                                käyttöehtoihin sovelletaan Suomen lakia 
                                riippumatta siitä, mistä maasta käyttäjä 
                                Mobiilipankkia käyttää.
                                <br />
                                <br />
                                Mobiilipankkia ja näitä Mobiilipankin käyttöehtoja 
                                koskevat erimielisyydet ratkaistaan ensisijaisesti 
                                neuvottelemalla. Jos asiaan ei saada ratkaisua 
                                neuvottelemalla, sopimusta koskevat erimielisyydet 
                                ratkaistaan Helsingin käräjäoikeudessa.
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): ITermsPageState => {
    return {
        ...mapStateToProps,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ITermsPageDispatchProps => {
    return {
        showBackNavigation: () => {
            return dispatch(SetShowBackNavigation(true));
        },
        HideBackButton: () => {
            return dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsPage);



// WEBPACK FOOTER //
// ./src/views/about/TermsPage.tsx